import React from "react";
import { C, radii, space } from "../../styles/tokens";

/**
 * StepProgress (docs/BRAND_MANUAL.md, section 8)
 * Step dots: 8px dots, the current one 24px wide pill in primary (#08833E).
 */
export function StepProgress({ step, total = 3 }) {
  const dots = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div
      role="progressbar"
      aria-label={`Step ${step} of ${total}`}
      aria-valuenow={step}
      aria-valuemin={1}
      aria-valuemax={total}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: space.sm, // 8px
        marginBottom: space.xl, // 20px
      }}
    >
      {dots.map((num) => {
        const isDone = num < step;
        const isCurrent = num === step;
        const width = isCurrent ? 24 : 8;
        const bg = isCurrent || isDone ? C.primary : C.divider;

        return (
          <div
            key={num}
            style={{
              width,
              height: 8,
              borderRadius: radii.pill,
              backgroundColor: bg,
              transition: "width 0.2s ease-out, background-color 0.2s ease-out",
            }}
          />
        );
      })}
    </div>
  );
}
